"use client"
import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { ContactHeroProps, RenderConfig } from "./RenderConfig"

export const SKEContactHero: ComponentConfig<ContactHeroProps> = {
  label: "SKE | Contact Hero",
  //@ts-ignore
  fields: {
    title: {
      type: "text",
      label: "Title (H1)",
    },
    description: {
      type: "textarea",
      label: "Description (Sapo)",
    },
    connectTitle: {
      type: "text",
      label: "Connect Title (H2 - screen reader)",
    },
    items: {
      type: "array",
      label: "Quick Contact Items",
      min: 0,
      max: 6,
      arrayFields: {
        iconType: {
          type: "select",
          label: "Icon",
          options: [
            { value: "phone", label: "Phone" },
            { value: "mail", label: "Mail" },
            { value: "consult", label: "Consult" },
          ],
        },
        label: {
          type: "text",
          label: "Label",
        },
        value: {
          type: "text",
          label: "Value",
        },
        ctaText: {
          type: "text",
          label: "CTA Text",
        },
        ctaLink: {
          type: "text",
          label: "CTA Link",
        },
      },
    },
    ...commonStylesProps,
  },
  defaultProps: {
    title: "Liên hệ Hệ thống Giáo dục Sky-Line",
    description:
      "Sky-Line luôn sẵn sàng đồng hành và giải đáp các thông tin về chương trình học, tuyển sinh, học phí và hệ thống cơ sở. Quý Phụ huynh có thể lựa chọn hình thức liên hệ phù hợp bên dưới.",
    connectTitle: "Kết nối với Sky-Line",
    items: [
      {
        iconType: "phone",
        label: "Hotline",
        value: "(+84) 236.378.7777",
        ctaText: "Gọi ngay",
        ctaLink: "tel:+842363787777",
      },
      {
        iconType: "mail",
        label: "Email",
        value: "info.contact@skylineschool.edu.vn",
        ctaText: "Gửi email",
        ctaLink: "mailto:info.contact@skylineschool.edu.vn",
      },
      {
        iconType: "consult",
        label: "Tư vấn tuyển sinh",
        value: "Nhận tư vấn chương trình học và học phí",
        ctaText: "Đăng ký tư vấn",
        ctaLink: "#",
      },
    ],
    className: "",
    styles: {
      mobile: { display: "block" },
      tablet: { display: "block" },
      desktop: { display: "block" },
    },
  },
  ...RenderConfig,
}
